import PropTypes from 'prop-types';

import config from '../../../config';

import ProjectDetails from './ProjectDetails';
import ProjectParticipants from './ProjectParticipants';
import ProjectSharedDocuments from './ProjectSharedDocuments';
import ProjectStatsQuitus from './ProjectStatsQuitus';
import ProjectStatsDocuments from './ProjectStatsDocuments';
import RequiredDocumentsInformationMessage from './informationMessages/RequiredDocumentsInformationMessage';
import GrantAccessInformationMessage from './informationMessages/GrantAccessInformationMessage';
import PandaBox from './PandaBox';

function ProjectDashboard(props) {
  const baseUrl = `/project/${props.project.projectId}/intervention/${props.myIntervention.interventionId}`;
  return (
    <>
      <PandaBox
        project={props.project}
      />
      <RequiredDocumentsInformationMessage
        project={props.project}
        baseUrl={baseUrl}
        onRefresh={props.onRefresh}
      />
      <GrantAccessInformationMessage
        onRefresh={props.onRefresh}
        myIntervention={props.myIntervention}
        project={props.project}
        baseUrl={baseUrl}
      />
      <div className="row-eq-height">
        <div className="col-xl">
          <div className="row">
            <div className="col-12 col-md-6 col-xl-3 order-0">
              <ProjectDetails
                project={props.project}
                interventions={props.interventions}
              />
            </div>
            <div className="col-12 col-xl-6 order-2 order-xl-1">
              {config.featureFlags.showProjectKPIs ?
                <>
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <ProjectParticipants
                        myIntervention={props.myIntervention}
                        project={props.project}
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <ProjectStatsQuitus
                        myIntervention={props.myIntervention}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <ProjectStatsDocuments
                        myIntervention={props.myIntervention}
                      />
                    </div>
                  </div>
                </> :
                <div className="row">
                  <div className="col-12">
                    <ProjectParticipants
                      myIntervention={props.myIntervention}
                      project={props.project}
                    />
                  </div>
                </div>
              }
            </div>
            <div className="col-12 col-md-6 col-xl-3 order-1 order-xl-2">
              <ProjectSharedDocuments
                documents={props.projectSharedDocuments}
                onAddProjectSharedDocument={props.onAddProjectSharedDocument}
                onUploadProjectSharedDocument={props.onUploadProjectSharedDocument}
                onRequireProjectSpecificDocument={props.onRequireProjectSpecificDocument}
                organisationId={props.organisationId}
                projectOwnerId={props.project.ownerOrganisation.organisationId}
                projectStatus={props.project.projectStatus}
                projectType={props.project.projectType}
                loading={props.loadingProjectSharedDocuments}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

ProjectDashboard.propTypes = {
  interventions: PropTypes.array.isRequired,
  project: PropTypes.object.isRequired,
  myIntervention: PropTypes.object.isRequired,
  organisationId: PropTypes.number.isRequired,
  projectSharedDocuments: PropTypes.array.isRequired,
  onAddProjectSharedDocument: PropTypes.func.isRequired,
  onUploadProjectSharedDocument: PropTypes.func.isRequired,
  onRequireProjectSpecificDocument: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
  loadingProjectSharedDocuments: PropTypes.bool.isRequired
};

export default ProjectDashboard;
